angular.module('unergie.main')
.directive('onScrollBottom', ($timeout, BarcodeService) =>
    ({
        restrict: 'A',
        link: (scope, element, attrs) => {
            const raw = element[0]
            element.bind('scroll', () => {
                if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight) {
                    scope.$apply(attrs.onScrollBottom)
                }
            })
        },
    }))
